const formSteps = document.querySelector('.form-steps');
const form = document.querySelector('.form');
const progress = document.querySelectorAll('.step');
const prevBtn = document.querySelectorAll('.back');
const nextBtn = document.querySelectorAll('.next');

let currentStep = 0;

// show the current step
function showStep(stepIndex) {
    const fieldsets = form.querySelectorAll('fieldset');
    fieldsets.forEach((fieldset) => {
        fieldset.classList.remove('active');
    });
    fieldsets[stepIndex].classList.add('active');
    updateProgressBar(stepIndex);
}

// update the progress bar
function updateProgressBar(currentStep) {
    progress.forEach((step, index) => {
        if (index <= currentStep) {
            step.classList.add('active');
        } else {
            step.classList.remove('active');
        }
    });
}

function fromURL() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const step = urlParams.get('step')
    const step1_option = urlParams.get('step1_option')
    const step2_option = urlParams.get('step2_option')


    if (step != null) {
        currentStep = parseInt(step) - 1
        document.querySelectorAll('.form_step').forEach((step) => {
            step.classList.remove('active')
        })
        document.querySelector('.form_step.step' + step).classList.add('active')
    }

    if (step1_option != null) {
        document.querySelectorAll('.form_step.step1 .option').forEach((option) => {
            option.classList.remove('active')
        })
        document.querySelectorAll('.form_step.step1 .option')[(step1_option - 1)].classList.add('active')
    }

    if (step2_option != null) {
        document.querySelectorAll('.form_step.step2 .option').forEach((option) => {
            option.classList.remove('active')
        })
        document.querySelectorAll('.form_step.step2 .option')[(step2_option - 1)].classList.add('active')
    }
}

// go to the previous step
function prevStep() {
    if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
    }
}

// go to the next step
function nextStep() {
    if (currentStep < progress.length - 1) {
        currentStep++;
        showStep(currentStep);
    }
}

// go back to home
function backToHome() {
    formSteps.style.display = 'none';
    // add your own code to redirect to the home page or hide the form
}

function selectOption(optionSelected, step_number) {
    document.querySelector('.form .step' + step_number).querySelectorAll('.option').forEach((option) => {
        option.classList.remove('active')
    })
    optionSelected.classList.add('active')
    updateCurrentSelectedOffer()
    showBadge();
    showMention();
    showMentionText();
}

function updateCurrentSelectedOffer() {
    var first_key = document.querySelectorAll('.form_step .option.active')[0].dataset.combinaisonKey
    var second_key = document.querySelectorAll('.form_step .option.active')[1].dataset.combinaisonKey
    document.querySelectorAll('.issue').forEach((issue) => {
        if (issue.dataset.combinaisonKey == first_key + second_key) {
            issue.classList.add('active')
        } else {
            issue.classList.remove('active')
        }
    });
}

function getCurrentSelectedOfferID() {
    return parseInt(document.querySelector('.issue.active').dataset.variantId)
}

function getCurrentSelectedOfferPlanID() {
    return parseInt(document.querySelector('.issue.active').dataset.sellingplanId)
}

function showPopup() {
    document.getElementById("form-popup").style.display = "flex";
}

function closePopup() {
    document.getElementById("form-popup").style.display = "none";
}

function takeOffer(offerKey) {

  const selectedKey = document.querySelector('.form .step1 .option.active')?.dataset.combinaisonKey;
console.log('this is function call')
  const redirectMap = {
    '1chat': 'https://pay.mein-pacha.de/de/checkout/add/?product=13:1:12:week',
    '2chats': 'https://pay.mein-pacha.de/de/checkout/add/?product=9:1:12:week',
    '3chats': 'https://pay.mein-pacha.de/de/checkout/add/?product=6:1:12:week',
  };

  const redirectURL = redirectMap[selectedKey];

  if (redirectURL) {
    var _dm = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    window.location.href = redirectURL + (_dm ? '&coupon=' + encodeURIComponent(_dm[1]) : '');
  } else {
    alert("Erreur : combinaison inconnue (" + selectedKey + ")");
  }
}


function checkoutWithNoUpsell() {
  const selectedOptions = document.querySelectorAll('.form_step .option.active');
  if (selectedOptions.length < 2) {
    alert("Erreur : aucune combinaison sélectionnée.");
    return;
  }

  const key1 = selectedOptions[0].dataset.combinaisonKey;
  const key2 = selectedOptions[1].dataset.combinaisonKey;
  const combinaison = key1 + key2;

  const redirectMap = {
    '1chat1mois': 'https://pay.mein-pacha.de/de/checkout/add/?product=15:1:4:week',
    '2chats1mois': 'https://pay.mein-pacha.de/de/checkout/add/?product=11:1:4:week',
    '3chats1mois': 'https://pay.mein-pacha.de/de/checkout/add/?product=7:1:4:week',
  };

  const redirectURL = redirectMap[combinaison];

  if (redirectURL) {
    var _dm = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    window.location.href = redirectURL + (_dm ? '&coupon=' + encodeURIComponent(_dm[1]) : '');
  } else {
    alert("Erreur : combinaison inconnue (" + combinaison + ")");
  }
}



function checkout(popup_id = null) {
    var popupTriggered = false
    if (popup_id != null && !document.querySelector('.next-checkout-v2').classList.contains('popupTriggered')) {
        document.querySelectorAll('.form_step').forEach((step) => {
            if (step.querySelector('.option.active') != null && step.querySelector('.option.active').dataset.combinaisonKey == popup_id) {
                showPopup()
                popupTriggered = true
                document.querySelector('.next-checkout-v2').classList.add('popupTriggered')
            }
        })
    }

    // if (!popupTriggered) {
    //     var checkOutChampId = document.querySelector('.issue.active').getAttribute('data-checkoutchamp-id');
    //     let formData = {
    //         'items': [{
    //             'id': getCurrentSelectedOfferID(),
    //             'selling_plan': getCurrentSelectedOfferPlanID(),
    //             'quantity': 1
    //         }]
    //     };
       
    //     fetch(window.Shopify.routes.root + 'cart/add.js', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(formData)
    //     })
    //         .then(response => {
    //             if(checkOutChampId){
    //                 location.href = `https://checkout.mein-pacha.de/checkout?products=${checkOutChampId}:1`
    //             }else{
    //                 location.href = `/checkout`;
    //             }
    //             return response.json();
    //         })
    //         .catch((error) => {
    //             // console.error('Error:', error);
    //         });
    // }
    if (!popupTriggered) {
        var checkOutChampId = document.querySelector('.issue.active').getAttribute('data-checkoutchamp-id');
        const nextCommerceData = [
                        {"shopifyId":  "48305655087439", "nextCommerceId": "6", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "48305655316815", "nextCommerceId": "7", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "48305655775567", "nextCommerceId": "9", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "48305655972175", "nextCommerceId": "11", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "48305656234319", "nextCommerceId": "13", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "48305657151823", "nextCommerceId": "15", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "54068721975631", "nextCommerceId": "17", "IntervalCount": "", "FrequencyTitle": ""},
                        {"shopifyId":  "54258617286991", "nextCommerceId": "19", "IntervalCount": "", "FrequencyTitle": ""},
                        {"shopifyId":  "54776617369935", "nextCommerceId": "21", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "54776260821327", "nextCommerceId": "24", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689603252559", "nextCommerceId": "25", "IntervalCount": "3", "FrequencyTitle": "week"},
                        {"shopifyId":  "54776266522959", "nextCommerceId": "27", "IntervalCount": "3", "FrequencyTitle": "week"},
                        {"shopifyId":  "54776631066959", "nextCommerceId": "29", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689634906447", "nextCommerceId": "31", "IntervalCount": "3", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689632416079", "nextCommerceId": "33", "IntervalCount": "3", "FrequencyTitle": "week"},
                        {"shopifyId":  "54776252498255", "nextCommerceId": "35", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "54776264065359", "nextCommerceId": "37", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689654337871", "nextCommerceId": "39", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689607217487", "nextCommerceId": "41", "IntervalCount": "3", "FrequencyTitle": "week"},
                        {"shopifyId":  "54776612585807", "nextCommerceId": "43", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689638674767", "nextCommerceId": "45", "IntervalCount": "3", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689650700623", "nextCommerceId": "47", "IntervalCount": "3", "FrequencyTitle": "week"},
                        {"shopifyId":  "54776621400399", "nextCommerceId": "49", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "54776257249615", "nextCommerceId": "51", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689641525583", "nextCommerceId": "53", "IntervalCount": "3", "FrequencyTitle": "week"},
                        {"shopifyId":  "54776641421647", "nextCommerceId": "55", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689605939535", "nextCommerceId": "57", "IntervalCount": "3", "FrequencyTitle": "week"},
                        {"shopifyId":  "55689646276943", "nextCommerceId": "59", "IntervalCount": "3", "FrequencyTitle": "week"}
                    ];
        // First clear the cart
        fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(() => {
            // After clearing, add the product
            let formData = {
                'items': [{
                    'id': getCurrentSelectedOfferID(),
                    'selling_plan': getCurrentSelectedOfferPlanID(),
                    'quantity': 1
                }]
            };
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
        })
        .then(response => {
          

             $.getJSON('/cart.js', function(cart) {
                    cart.items.forEach(function(item) {
                        console.log("Cart Variant ID:", item.id, "Product ID:", item.product_id);

                        // Compare variant ID
                        var match = nextCommerceData.find(function(nc) {
                            return nc.shopifyId == item.id;
                        });

                        if(match) {
                          console.log("Matched Variant ID:", item.id, "NextComment:", match.nextCommerceId);
                           let matchId = match.nextCommerceId;
                            let IntervalCount = match.IntervalCount;
                            let FrequencyTitle = match.FrequencyTitle;

                            let url = `https://pay.mein-pacha.de/de/checkout/add/?product=${matchId}:1`;

                            // only add IntervalCount if it exists
                            if (IntervalCount && IntervalCount !== "") {
                              url += `:${IntervalCount}`;
                              // only add FrequencyTitle if IntervalCount is there
                              if (FrequencyTitle && FrequencyTitle !== "") {
                                url += `:${FrequencyTitle}`;
                              }
                            }

                            // Offre tapis retiree le 30/07/2026 : le cadeau n'est autorise que sur FR et UK. ?bonus=tapis n'ajoute plus rien, y compris depuis un ancien lien.
                            var _dm = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
                            if (_dm) { url += '&coupon=' + encodeURIComponent(_dm[1]); }
                            window.location = url;
                          }else{
                            location.href = `/checkout`;
                          }
                    });
                });
           
            // if (checkOutChampId) {
            //     location.href = `https://checkout.mein-pacha.de/checkout?products=${checkOutChampId}:1`;
            // } else {
            //     location.href = `/checkout`;
            // }
            return response.json();
        })
        .catch((error) => {
            // console.error('Error:', error);
        });
    }
}

function showBadge() {
    document.querySelectorAll('.option-badge, .popup-badge').forEach((badge) => {
        badge.classList.remove('active')
    })
    document.querySelector('.option-badge[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
    document.querySelector('.popup-badge[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
}

function showMentionText() {
    document.querySelectorAll('.option-mention').forEach((mention) => {
        mention.classList.remove('active');
    });
    document.querySelectorAll('.option-mention[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').forEach((mention) => {
        mention.classList.add('active');
    });
    console.log(document.querySelector('.form .step1 .option.active'))
}

function showMention() {
    // On retire toutes les classes actives
    document.querySelectorAll('.popup-mention').forEach((el) => el.classList.remove('active'));
    document.querySelectorAll('.title-popup-titre').forEach((el) => el.classList.remove('active'));
    document.querySelectorAll('.title-popup-description').forEach((el) => el.classList.remove('active'));

    // On récupère la clé sélectionnée
    const key = document.querySelector('.form .step1 .option.active')?.dataset.combinaisonKey;
    if (!key) return;

    // On active les bons éléments selon la clé
    document.querySelectorAll('.popup-mention[data-condition="' + key + '"]').forEach((el) => el.classList.add('active'));
    document.querySelectorAll('.title-popup-titre[data-condition="' + key + '"]').forEach((el) => el.classList.add('active'));
    document.querySelectorAll('.title-popup-description[data-condition="' + key + '"]').forEach((el) => el.classList.add('active'));
}



// initialize the form
function initForm() {
    showStep(currentStep);

    document.querySelector('.form .step1').querySelectorAll('.option')[0].classList.add('active')
    document.querySelector('.form .step2').querySelectorAll('.option')[1].classList.add('active')

    prevBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            prevStep();
        });
    });

    nextBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            nextStep();
        });
    });
    updateCurrentSelectedOffer();
    showBadge()
    showMention()
    showMentionText()
    fromURL()
}

initForm();
